<span class="flex row justify-center">
	<p class="mat-slider-prefix" (click)="toggle()">{{ prefixLabel }}</p>
	<mat-slide-toggle #slider [color]="color" [checked]="checked" (change)="handleChange()">{{ label }}</mat-slide-toggle>
</span>
